import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController, DropdownOptionsTypes } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";
import { GlobalConstants, LmsAccountingResidualHandling } from "../../constants/GlobalConstants";
import { PayoffQuoteLoanCommentForm } from "../ui/LmsSharedForms";
import { convertToDateString } from "../../../Helpers";

const MainTable = () => {
  const actionsButtons = ["edit", "export"];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="payoffquotes/residual-amount-queues"
    columnLabelsDictionary={{ borrowerOrganization: "Borrower", loanNumber: "Loan #" }}
    columnClickOptions={{
      loanNumber: {
        path: "/accounting-residual-amounts-queue/edit",
        idProp: "id",
      },
    }}
  />;
};

const editAccountingResidualAmountsQueueFormFields = (myForm: BCFormController, loanId= "", payoutResidualDropDown: DropdownOptionsTypes | undefined) => {
  myForm.addCenteredGroup([
    myForm.getDropdownField(
      "Borrower",
      "metadata/list-borrower-organizations",
      { name: "borrowerOrganizationId", disabled: true }
    ),

  myForm.getInputField(
      "Current Loan Balance", 
      { name: "loanAmountCurrent", fieldType: "dollar", required: true, disabled: true }
    ),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Special Purpose Entity", "orgs/list-special-purpose-entities", { name: "specialPurposeEntityId", disabled: true, dependencyField: "borrowerOrganizationId" }),
    myForm.getInputField("Interest Reserve Balance", { fieldType: "dollar", required: true, disabled: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Loan", { name: "loanDisplay", disabled: true }),
    myForm.getInputField("Current Interest Rate", { name: "interestRateCurrent", fieldType: "dollar", disabled: true, required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Escrow #", { name: "payoffEscrowNo", disabled: true }),
    myForm.getDropdownField("Fund", "orgs/list-fund-orgs", { width: 4, name: "fundOrganizationId", disabled: true })
  ]);

  let pdPeriod1, pdPeriod2;
  if (myForm?.initialValues?.pdStartDate1 && myForm?.initialValues?.pdEndDate1) {
    pdPeriod1 = `${convertToDateString(myForm?.initialValues?.pdStartDate1, "lmsdisplaydateforfieldname")}-${convertToDateString(myForm?.initialValues?.pdEndDate1, "lmsdisplaydateforfieldname")}`;
  }

  if (myForm?.initialValues?.pdStartDate2 && myForm?.initialValues?.pdEndDate2) {
    pdPeriod2 = `${convertToDateString(myForm?.initialValues?.pdStartDate2, "lmsdisplaydateforfieldname")}-${convertToDateString(myForm?.initialValues?.pdEndDate2, "lmsdisplaydateforfieldname")}`;
  }

  myForm.addCenteredGroup([
    myForm.getCurrencyField(pdPeriod1 ? pdPeriod1 : "Interest Pdstart Pdend1", { name: "interestPdstartPdend1", required: true, disabled: true }),
    (pdPeriod2 ? myForm.getCurrencyField(pdPeriod2, { name: "interestPdstartPdend2", required: true, disabled: true }) : myForm.getBlankField())
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Bank", "payoffquotes/list-fund-bank-info", { dependencyField: "fundOrganizationId", disabled: true, name: "bankInformationId" }),
    myForm.getInputField("Per Diem Interest", { disabled: true, required: true, fieldType: "dollar" }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Payout Date", { disabled: true }),
    myForm.getCheckboxField("Prorate Extension", { inline: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getCalendarField("Valid Through Date", { disabled: true }),
    myForm.getInputField("Extension Fee", { fieldType: "dollar", disabled: true, required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Refi", { disabled: true }),
    myForm.getInputField("Per Diem Extension", { fieldType: "dollar", disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Original Loan Amount", { name: "loanDetailLoanAmountOriginal", fieldType: "dollar", disabled: true }),
    myForm.getCheckboxField("Include Sweep", { inline: true, disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Days In Extension", { disabled: true }),
    myForm.getInputField("Sweep Amount", { fieldType: "dollar", disabled: true, required: true })
  ]);

  if (loanId) {
    myForm.addComponent(
      <LmsTable
        apiSuffix={`payoffquotes/property-unit-reconveyance/${loanId}`}
        displayOnlyProps={["unitNumber", "appraisedValue"]}
        columnLabelsDictionary={{ unitNumber: "Unit" }}
        isDisabled
      />
    );
  }

  if (myForm?.initialValues?.payoffQuoteLoanComments) {
    myForm.addGroupFields([
      myForm.getComponent((options) =>
        <LmsTable
          data={myForm?.initialValues?.payoffQuoteLoanComments}
          displayOnlyProps={["commentSubjectDisplay", "description", "createdOn", "createdBy"]}
          columnLabelsDictionary={{commentSubjectDisplay: "Subject"}}
          title="Payoff comments"
          refreshDataDependency={options?.inputs?.lastAddedCommentId}
          compact
          isDisabled
        />,
      { width: 9 }),
      myForm.getComponent(() => {
        const commentsHtml = myForm?.initialValues?.commentsHtml?.length ? myForm?.initialValues?.commentsHtml.split("<br />") : null;
        return <>
          {commentsHtml?.length >= 1 && <div className="lms-comments-html-div">
            {commentsHtml?.map((comment) => {
              return <p className="lms-comments-html">{comment}</p>;
            })}
          </div>}
        </>;
      }, { width: 5 }),
      myForm.getButtonField("Add Comment", undefined, {
        modalContent: (setIsAddCommentModalOpen, options) => (
          <PayoffQuoteLoanCommentForm
            payoffQuoteOptions={options}
            id={myForm?.values?.loanId} 
            setIsAddCommentModalOpen={setIsAddCommentModalOpen} 
          />
        ),
        modalSize: "large",
        width: 2,
        disabled: true
      })
    ]);
  }

  myForm.addCenteredGroup([
    myForm.getInputField("Sweep % Amount", { name: "sweepPercentage", fieldType: "percent", disabled: true, required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Additional Interest Basis", "metadata/list-additional-interest-basis", { disabled: true, required: true, name: "additionalInterestBasisId" }),
    myForm.getInputField("Additional Interest Floor", { fieldType: "dollar", disabled: true, required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Additional Interest %", { fieldType:"percent", name:"additionalInterestRate", required: true, disabled: true }),
    myForm.getInputField("Additional Interest", { fieldType: "dollar", name: "additionalInterestAmount", disabled: true, required: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Reconveyance Fee", { fieldType: "dollar", disabled: true, required: true }),
    myForm.getDropdownField("Additional Payoff Fees", "metadata/list-transaction-types", { disabled: true, name: "transactionTypeId" }),
  ]);
  
  myForm.addCenteredGroup([
    myForm.getInputField("Late Fee Amount", { fieldType: "dollar", disabled: true }),
    myForm.getCheckboxField("Charge Payoff Fee", { inline: true, disabled: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getInputField("Previous Fee", { fieldType: "dollar", disabled: true }),
    myForm.getInputField("Total Payout", { fieldType: "dollar", name: "payoffQuoteAmount", disabled: true }),
  ]);

  const payoutResidual = myForm?.initialValues?.receivedAmount - myForm?.initialValues?.payoffQuoteAmount;
  myForm.addCenteredGroup([
    myForm.getInputField("Payout Received", { fieldType: "dollar", disabled: true }),
    myForm.getInputField("Payout Residual", { fieldType: "dollar", disabled: true, value: payoutResidual }),
  ]);

  myForm.addCenteredGroup([
    myForm.getDropdownField("Residual Handling", payoutResidualDropDown, { name:"payoffResidualHandlingOption", required: true }),
    myForm.getDropdownField("Loan Sub Status", "metadata/list-loan-sub-statuses", { name: "loanSubStatusId", disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Comments/Instructions", { disabled: true }),
  ]);

  myForm.addCenteredGroup([
    myForm.getButtonField("Settlement Statement / Escrow Request", undefined, { disabled: true, buttonIcon: GlobalConstants.Icons.CHEVRON_DOWN  })
  ]);
  
  return myForm;
};

const EditAccountingResidualAmountsQueueForm = ({ id }) => {
  const [{ data = {}, error, isLoading }] = useFetchData(`payoffquotes/initial-data-for-edit/${id}`);
  const loanId = data?.loanId || "";
  const payoutResidualConditionalForGTZero =
    LmsAccountingResidualHandling.filter(({ key }) => {
      return key !== "Refer to Collections";
    });

  const payoutResidualConditionalForLTZero = LmsAccountingResidualHandling.filter(({ key }) => {
    return (key !== "Sweep" && key !== "Refund" && key !== "Process Sweep");
  });

  const payoutResidualDropDown = data?.loanAmountCurrent !== undefined ? data?.loanAmountCurrent > 0 ? payoutResidualConditionalForGTZero: payoutResidualConditionalForLTZero: "";
  const myForm = new BCFormController(data, { 
    metaData: { commentsHtml: data?.commentsHtml?.length ? data?.commentsHtml?.split("<br />") : null },
    submitMethod: "POST", 
    submitSuffix: "payoffquotes/residual-amount-queues/apply-residual-transaction", 
    blankWidth: 1 
  });
  editAccountingResidualAmountsQueueFormFields(myForm, loanId, payoutResidualDropDown);
  const formActions = [{ text:"Apply Residual Transaction", action: "save-close"}, "close"];
  return <LmsFormGenerator
    myForm={myForm}
    isLoading={isLoading}
    error={error}
    actions={formActions}
  />;
};

const LmsAccountingResidualAmountsQueue = ({ params = {}, history }) => {
  const { isActionAllowed, isEdit, id, isMainPage } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isEdit && <EditAccountingResidualAmountsQueueForm id={id} />}
    </>
  );
};

export default LmsAccountingResidualAmountsQueue;